import clsx from 'clsx'
import { Grid, makeStyles, useTheme, Collapse, useMediaQuery } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
    gridItem: {
        cursor: 'pointer',
        transition: '0.5s',
        marginTop: '20px',
    },
    logo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        border: '1px solid #eee',
        borderRadius: '10px',
        overflow: 'hidden',
    },
    title: {
        marginLeft: '20px',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    detail: {
        backgroundColor: '#eee',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '10px',
        height: '440px',
    },
    content: {
        overflowY: 'scroll',
        height: '420px',
        width: '100%',
        paddingBottom: '20px',
    },
    collapse: {
        position: 'absolute !important', 
        left: '0 !important', 
        width: '100% !important'
    },
    highlight: {
        color: '#009EFF',
    },
}))

const RestrictedProductList = (props) => {
    const { data, open, onExpand, onClose } = props

    const classes = useStyles()

    return (
        <Grid container style={{ position: 'relative' }}>
            {Object.entries(data).map(([k, v]) => {
                const isOpen = open === k

                return (
                    <Grid
                        item
                        key={k}
                        xs={12}
                        sm={6}
                        lg={4}
                        className={classes.gridItem}
                        style={{ marginBottom: isOpen ? '460px' : '0px' }}
                        onClick={() => onExpand(k)}
                    >
                        <Grid container>
                            <Grid item sm={5} md={6}>
                                <div className={classes.logo}>
                                    {v.logo}
                                </div>
                            </Grid>
                            <Grid item sm={5} md={6}>
                                <div className={clsx(classes.title, isOpen && classes.highlight)}>
                                    <p>{v.title}</p>
                                </div>
                            </Grid>
                        </Grid>

                        <Collapse in={isOpen} className={classes.collapse}>
                            <Grid container className={classes.detail}>
                                <CloseIcon style={{ position: 'absolute', right: '10px' }} onClick={onClose} />
                                <Grid item className={classes.content}>
                                    {v.content}
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default RestrictedProductList